import {Link} from "react-router";
import {useContext, useEffect, useState} from "react";
import {SelectedActivities} from "../components/SelectedActivities.tsx";
import ActivityContext, {IResolvedActivity} from "../contexts/Activity.tsx";
import {calcItem} from "../helpers/calcItem.ts";
import {isMobile} from "../helpers/isMobile.ts";
import GeneralContext from "../contexts/Gneral.tsx";

export function ConfirmActivity () {
    const  data  = useContext(GeneralContext);
    const {resolvedActivities}  = useContext(ActivityContext);
    const [active, setActive]   = useState<IResolvedActivity|null>(null);
    const [selected, setSelected]   = useState<IResolvedActivity|null>(null);
    const [count, setCount] = useState<number>(-1);
    let _resolvedActivities = resolvedActivities.map( (item) => {
        return calcItem(item);
    }).sort((a,b)=> a.r > b.r ? 1 : -1);
    let scale = 0
    _resolvedActivities.slice(0,5).forEach((item) => {
        if(scale < item.scale){
            scale = item.scale
        }
    })
    // const el = document.querySelector('.selectingAside');
    // let clientHeight = el?.clientHeight && isMobile() ? (window.innerHeight * 0.59 - (window.innerHeight - el?.clientHeight))/2 : 0;
    useEffect(() => {
        setCount(0);

    }, []);
    scale = 1/(scale)* (isMobile() ? 0.7 : 0.8)
    return (<div  className={'builder-screen'}>
            <div className={'selectingAside'}>
                {active ?
                    <div className={'aside-content activities-aside'}>
                        <h1>{data?.contents.confirmActivityScreenHeading1}</h1>
                        <h1>{data?.contents.confirmActivityScreenHeading2}</h1>
                    </div>
                    :
                    <div className={'aside-content activities-aside'}>
                        <h1>{data?.contents.confirmActivityScreenHeading3}</h1>
                        <p>{data?.contents.confirmActivityScreenContent1}</p>
                        <p><small>{data?.contents.confirmActivityScreenContent3}<br />{data?.contents.confirmActivityScreenContent2}</small></p>
                    </div>
                }
                {active ?
                    <ul className={"other-activities"+ (_resolvedActivities.slice(5).length === 9 ? ' qty-9' : '')}>
                        {_resolvedActivities.slice(5).map( (item, index) =>{
                            return  <li key={index} className={selected?.activity === item.activity ? 'selected' : ''}>
                                <button aria-label={"Select " + item.activity.title} onClick={()=>{
                                    setSelected(item);
                                }}>
                                    <strong>{item.activity.title}</strong>
                                </button>
                            </li>
                        })}
                    </ul>
                    :
                    <ul className={"closest-activities"}>
                        {_resolvedActivities.slice(0,5).map((item, index) =>{
                            return <li key={index}>
                                <button aria-label={"Change " + item.activity.title} onClick={()=>{
                                    setActive(item);
                                    setCount( count + 1);
                                }}>
                                    <strong>{item.activity.title}</strong>
                                    <span className={"edit"}>Edit</span>
                                </button>
                            </li>
                        })}

                    </ul>
                }

                {active ?
                    <button className={"btn small"} onClick={() => {
                        if(selected){
                            let temp = Object.assign({},selected.position);
                            selected.position = Object.assign({},active.position);
                            active.position = temp;
                        }
                        setSelected(null);
                        setActive(null);
                    }}>המשך</button>
                    :
                    <Link to={"/activities-final"} className={"btn small"}>{count ? 'המשך' : 'דלג'}</Link>
                }
            </div>
            <div className={'visualArea mobileScale'} >
                {/*<SelectedActivities offsetY={-clientHeight} activities={_resolvedActivities} scale={scale} hideInactive={true} />*/}
                <SelectedActivities activities={_resolvedActivities} scale={scale} hideInactive={true} />
            </div>
    </div>);
}